module.exports = __webpack_public_path__ + "static/media/forward_normal_grey.efcd240d.svg";